import React from 'react'
import { SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import SuggestedProductCardCheckout from './SuggestedProductCard.Checkout';
import { StyledSuggestedProductSwiperCheckout } from '../Styles/SuggestedProductSlider.Styling';


const SuggestedProductsSliderCheckout = ({ suggestedProducts, sliderIntervalInSec }) => {
    return (
        <div className='flex flex-grow'>
            <StyledSuggestedProductSwiperCheckout
                pagination={false}
                navigation={true}
                slidesPerView={2}
                slidesPerGroup={2}
                modules={[Navigation, Autoplay]}
                breakpoints={{
                    1024: { slidesPerView: 4, slidesPerGroup: 4 },
                }}
                autoplay={sliderIntervalInSec ? { delay: sliderIntervalInSec * 1000 } : false}
                lazy={true} className="!h-full"
            >
                {suggestedProducts.map((product) => (
                    <SwiperSlide key={product.id} className="!h-auto">
                        <SuggestedProductCardCheckout product={product} className='h-full flex flex-col' />
                    </SwiperSlide>
                ))}
            </StyledSuggestedProductSwiperCheckout>
        </div>
    )
}

export default SuggestedProductsSliderCheckout